import Carousel from "../Carousel";
import BrandsWrapper from "../BrandsWrapper";
import { listUrl } from "../Data";

const brandList = listUrl.brandsCarousel.item

const BrandsCarousel = () => {
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 3,
    speed: 500,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          className: "center",
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          centerPadding: "100px",
          dots: true,
        }
      },
    ]
  };

  function NextArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      >
        <div className="ArrowRecogbition">
          <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.79435e-06 2.585L8.03509 11L1.05869e-06 19.415L2.47368 22L13 11L2.47369 -4.6012e-07L1.79435e-06 2.585Z" fill="#373737" />
          </svg>
        </div>
      </div>
    );
  }

  function PrevArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      >
        <div className="ArrowRecogbition">
          <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 19.415L4.96491 11L13 2.585L10.5263 1.18962e-06L1.44248e-06 11L10.5263 22L13 19.415Z" fill="#373737" />
          </svg>
        </div>
      </div>
    );
  }

  return (
    <Carousel settings={settings}>
      {brandList && brandList.map((item: any, index) => (
        <BrandsWrapper post={item.post} key={index} />
      ))}
    </Carousel>
  );
};

export default BrandsCarousel;
